import PrevButton from "components/PrevButton";
import NextButton from "components/NextButton";
import SelectInput from "components/SelectInput";
import { yearsOptions } from "constants/index";
import { adequacySkipLinkText } from "i18n/messages/buttonTitles";
import { useSideModalScrollToTop } from "hooks";

const Subordinated = ({
    isSubordinatedVaild,
    isInvestmentFundsVaild,
    isBondsVaild,
    isSharesVaild,
    isSharingRightsVaild,
    setActiveStep,
    formatMessage,
    messages,
    formData,
    setFormData,
    setAdequacyStart,
    backSlideEffect = "",
    setBackSlideEffect,
    open,
    StatusAdequacy,
}) => {
    useSideModalScrollToTop();

    return (
        <>
            <div className={`subordinated multisteps ${backSlideEffect}`}>
                <div className="header-part">
                    <h4 className="primary-color">{formatMessage(messages.fifthHeading)}</h4>
                </div>
                <div className="content">
                    <form method="post" className="survey-form">
                        <div className="first-question">
                            <h3 className="mt-4 mb-7">{formatMessage(messages.fifthQuestion)}</h3>
                            <div className="tabs">
                                <div>
                                    <input
                                        id="subordinatedYes"
                                        type="radio"
                                        name="subordinated-experience"
                                        onChange={() =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                subordinated: {
                                                    ...prevState.subordinated,
                                                    IsSubordLoanXpConfirmed: true,
                                                },
                                            }))
                                        }
                                        checked={formData?.subordinated?.IsSubordLoanXpConfirmed === true}
                                    />
                                    <label
                                        className="medium mw-100"
                                        htmlFor="subordinatedYes"
                                        onClick={(e) =>
                                            jQuery(e.target).closest(".survey-form").find(".second-question").slideDown()
                                        }
                                    >
                                        {formatMessage(messages.yesText)}
                                    </label>
                                </div>

                                <div>
                                    <input
                                        id="subordinatedNo"
                                        type="radio"
                                        name="subordinated-experience"
                                        onChange={() =>
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                subordinated: {
                                                    ...prevState.subordinated,
                                                    IsSubordLoanXpConfirmed: false,
                                                    IsSubordLoanXpConfirmedDate: "",
                                                },
                                            }))
                                        }
                                        checked={formData?.subordinated?.IsSubordLoanXpConfirmed === false}
                                    />
                                    <label
                                        className="medium mw-100"
                                        htmlFor="subordinatedNo"
                                        onClick={(e) =>
                                            jQuery(e.target).closest(".survey-form").find(".second-question").slideUp()
                                        }
                                    >
                                        {formatMessage(messages.noText)}
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div
                            className="second-question"
                            style={{ display: formData?.subordinated?.IsSubordLoanXpConfirmed ? "block" : "none" }}
                        >
                            <div className="border-x" />
                            <h4>{formatMessage(messages.fifthQuestionOther)}</h4>
                            <div className="">
                                <SelectInput
                                    maxMenuHeight={400}
                                    isSearchable={false}
                                    menuPlacement="top"
                                    className="select form-item"
                                    classNamePrefix="select"
                                    name="subordinated-experience-years"
                                    options={yearsOptions()}
                                    placeholder={formatMessage(messages.pleaseSelect)}
                                    value={formData?.subordinated?.IsSubordLoanXpConfirmedDate || ""}
                                    onChange={(selectedOption) => {
                                        setFormData((prevState) => ({
                                            ...prevState,
                                            subordinated: {
                                                ...prevState.subordinated,
                                                IsSubordLoanXpConfirmedDate: selectedOption,
                                            },
                                        }));
                                    }}
                                />
                            </div>
                        </div>
                    </form>
                </div>
                {StatusAdequacy != "renew" && (
                    <span
                        onClick={() => {
                            setAdequacyStart({ step: 2 });
                            setBackSlideEffect("step-slide-right");
                        }}
                        className="skip-link"
                    >
                        {formatMessage(adequacySkipLinkText)}
                    </span>
                )}
            </div>
            {open && (
                <div className="bottom-bar-container">
                    <PrevButton
                        onClick={() => {
                            setActiveStep(4);
                            setBackSlideEffect("step-slide-right");
                        }}
                    />
                    <NextButton
                        className={`${isSubordinatedVaild ? "" : "disable-grey"}`}
                        onClick={() => {
                            setBackSlideEffect("step-slide-left");
                            isSubordinatedVaild &&
                                isInvestmentFundsVaild &&
                                isBondsVaild &&
                                isSharesVaild &&
                                isSharingRightsVaild &&
                                setAdequacyStart({ step: 7, survey_second_step: { ...formData, step: 5 } });
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default Subordinated;
